module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/public/gift/tip_i.png";